import { useControls } from 'react-zoom-pan-pinch';
import { FaArrowsToDot, FaMagnifyingGlassMinus, FaMagnifyingGlassPlus } from 'react-icons/fa6';
import styles from './Controls.desktop.module.css';
import React, { type CSSProperties } from 'react';
import { useEditMarket } from '../../../provider/edit-market/EditMarket.hook.ts';
import { useTranslation } from 'react-i18next';

export default function ControlsDesktopView() {
  const { t } = useTranslation();
  const { zoomIn, zoomOut, resetTransform } = useControls();
  const { enableZoom } = useEditMarket();

  return (
    <div
      className={styles.zoomContainer}
      style={
        {
          '--pointerEvent': enableZoom ? 'auto' : 'none',
        } as CSSProperties
      }
    >
      <img className={styles.logo} src="/images/logo192.png" alt={t('ui.altLogo')} />

      <hr className={styles.horizontalSeparator} />

      <FaMagnifyingGlassPlus onClick={() => zoomIn()} className={styles.zoomIcon} />

      <hr className={styles.horizontalSeparator} />

      <FaMagnifyingGlassMinus onClick={() => zoomOut()} className={styles.zoomIcon} />

      <hr className={styles.horizontalSeparator} />

      <FaArrowsToDot onClick={() => resetTransform()} className={styles.zoomIcon} />
    </div>
  );
}
